import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

//import redux

import {
  checkListOpenAction,
  checkListSwitchAction,
  evaluationToggleOffAction,
  helpToggleAction,
  itemReviewListOpenAction,
  quotationListOpenAction,
} from "../../features/sliceReducer/interactionReducer";
import {
  addCopiedCount,
  checkAction,
  deleteReferenceAction,
  selectItemAction,
  setManualPointAction,
  updateGeneralContent,
  updateRegulationContent,
  writtenContentsAction,
} from "../../features/sliceReducer/myProjectReducer";
import {RootState} from "../../features/store";

// material-UI
import {createStyles, makeStyles, Theme, useTheme, withStyles} from "@material-ui/core/styles";

import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";

//material-icons
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import EventNoteIcon from "@material-ui/icons/EventNote";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import PhotoIcon from "@material-ui/icons/Photo";

//import Component
import SpeedDials from "../../components/SpeedDials";

import ListSelect from "../../components/ListSelect";
import ListTitle from "../../components/ListTitle";

import IPConstants from "../../classes/IPConstants";
import IPUtility from "../../classes/IPUtility";
import ItemReviewListModal from "../../components/ItemReviewListModal";
import useCopyClipBoard from "../../customHook/useCopyClipBoard";
import {initializeIPItemReview} from "../../models/IPItemReview";
import {IPProject} from "../../models/IPProject";
import CheckListModal from "../checkList/CheckListModal";
import FieldCheckSearchModal from "../checkList/FieldCheckSearchModal";
import AddProjectModal from "./AddProjectModal";
import QuotationListModal from "./QuotationListModal";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      borderBottom: "1px solid grey",
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      overflowX: "hidden",
    },
    listContainer: {
      backgroundColor: theme.palette.custom.main,
      color: theme.palette.text.secondary,
    },

    table: {
      minWidth: "1800px",
    },

    header: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "& p": {
        paddingRight: "20px",
        color: "#076875",
        fontSize: "14px",
        fontWeight: 700,
      },
    },
    tableHead: {
      backgroundColor: theme.palette.gray.light,
    },
    tableBody: {
      overflow: "scroll",
      backgroundColor: theme.palette.gray.dark,
      "& td": {
        borderRight: "1px solid #dbdce0",
      },
    },

    itemValue: {
      display: "flex",
      alignItems: "center",
      marginBottom: "20px",
      border: "1px solid #dbdce0",
    },

    writer: {
      display: "flex",
      flex: "1 0 auto",
      height: "auto",
      padding: "12px",
    },

    item: {
      flex: "1 1 100%",
      padding: "12px",
      borderLeft: "1px solid #dbdce0",
      "& p:not(:last-of-type)": {
        paddingBottom: "4px",
      },
    },

    itemHead: {
      position: "relative",
    },
    btnAttachBox: {
      display: "flex",
      alignItems: "center",
      padding: "16px 0 0 16px",
    },
    btnSearch: {
      position: "absolute",
      bottom: "32px",
      right: "32px",
    },
    btnReview: {
      position: "absolute",
      bottom: "32px",
      right: "120px",
    },
    iputAlign: {
      "& input": {
        textAlign: "center",
      },
      "& input[type=number]": {
        "-moz-appearance": "textfield",
      },
      "& input[type=number]::-webkit-outer-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
      "& input[type=number]::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
    },
    buttonCell: {
      display: "flex",
      justifyContent: "space-around",
    },

    buttonMargin: {
      flex: "0 0 auto",
      width: "80px",
      height: "36px",
      marginRight: "18px",
    },

    guideButton: {
      width: "52px",
      height: "32px",
      marginRight: "18px",
    },

    textArea: {
      // width: "320px",
      flex: "1 1 100%",
      fontFamily: 'Roboto, "Noto Sans KR"',
      fontSize: "14px",
      lineHeight: 1.5,
      resize: "vertical",
      padding: "4px",
      color: theme.palette.text.secondary,
      backgroundColor: theme.palette.input.main,
    },

    MuiTableCellRoot: {
      fontSize: 10,
      color: "red",
    },

    TableCell: {
      fontSize: 10,
    },
    score: {
      textAlign: "center",
      paddingBottom: "32px",
      "& p": {
        paddingBottom: "8px",

        "& strong": {
          fontWeight: "bold",
          fontSize: "16px",
          color: theme.palette.primary.dark,
          letterSpacing: "0.4rem",
        },
      },
    },
    evaluation: {
      zIndex: 100,
      position: "fixed",
      top: "100px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "500px",
      color: "white",
      backgroundColor: "rgba(74,101,90,0.8) ",
      border: "2px solid",
      borderColor: theme.palette.primary.main,
      "& table": {
        width: "100%",
        fontFamily: "'Nanum Pen Script', cursive",
        textAlign: "center",
        fontSize: "14px",
        "& th, td": {
          padding: "12px",
          border: "2px solid #dbdce0",
        },
      },
    },
    help: {
      zIndex: 100,
      position: "fixed",
      top: "100px",
      left: "25%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "50%",
      padding: "10px",
      fontSize: "14px",
      color: theme.palette.info.main,
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.info.main}`,
      "& p": {
        paddingRight: "24px",
        lineHeight: "1.2",
      },
      "& span": {
        color: theme.palette.info.main,
      },
    },
  })
);

type writtenContentPayload = {
  itemUid: number;
  point: number;
  general?: string;
  regulation?: string;
  instruction?: string;
  recommendation?: string;
};

const EditMyProject = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const theme = useTheme();

  const {
    myProject,
    isSavedToServer,
    saveTime,
    getReference,
    loading,
    isGuideShow,
    checked,
    selectCategory,
    selectContainer,
    selectItem,
    quotationFiltering,
    EditProjectTableHeader: tableHeader,
  } = useSelector((state: RootState) => state.myProject);

  const {evaluationToggle, helpToggle, quotationListModalToggle} = useSelector(
    (state: RootState) => state.interaction
  );

  const {userToken} = useSelector((state: RootState) => state.auth);
  const thisUser = useSelector((state: RootState) => state.auth.user);
  const [reviewItemValue, setReviewItemValue] = useState({
    ...initializeIPItemReview,
  });

  const [textareaCopy, setTextareaCopy] = useState("");
  const [isCopy, onCopy] = useCopyClipBoard();

  const handleCopyClipBoard = (text: string) => {
    onCopy(text);
  };

  const [generalKey, setGeneralKey] = useState(IPUtility.generateUUID());
  const [regulationKey, setRegulationKey] = useState(IPUtility.generateUUID());
  const [instructionKey, setInstructionKey] = useState(IPUtility.generateUUID());
  const [recommendationKey, setRecommendationKey] = useState(IPUtility.generateUUID());

  const openItemReviewList = (isMeeting: boolean) => {
    setIsMeeting(isMeeting);
    dispatch(itemReviewListOpenAction());
  };

  const [isMeeting, setIsMeeting] = useState(false);

  const [scoreProject, setScoreProject] = useState({} as IPProject);
  const [containerAssignedPoint, setContainerAssignedPoint] = useState(0);
  const [containerEvalPoint, setContainerEvalPoint] = useState(0);
  useEffect(() => {
    const projectX = IPUtility.CalculateProjectPoints(myProject);
    setScoreProject({...projectX});
    const currentCategory = projectX.categories.find((x) => x.uid == selectCategory);
    if (currentCategory && currentCategory.containers.length == 1) {
      setContainerAssignedPoint(currentCategory.assignedPoint);
      setContainerEvalPoint(currentCategory.evalPoint);
    } else {
      setContainerAssignedPoint(
        IPUtility.getContainerByUID(projectX, selectContainer).assignedPoint
      );
      setContainerEvalPoint(IPUtility.getContainerByUID(projectX, selectContainer).evalPoint);
    }
  }, [myProject, selectContainer, selectCategory]);

  if (myProject.isNoPoint) dispatch(evaluationToggleOffAction());

  return (
    <>
      <AddProjectModal />
      <CheckListModal />
      <QuotationListModal />
      <FieldCheckSearchModal />
      <ItemReviewListModal isMeeting={isMeeting} containerUID={selectContainer} />

      {/* {quotationListModalToggle || <Loading loading={loading} />} */}
      <div
        style={{
          position: "fixed",
          top: "80px",
          left: 0,
          width: "100%",
          height: "180px",
          zIndex: 100,
        }}
      >
        <ListTitle subTitle={"Edit MyProject"}></ListTitle>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          className={classes.listContainer}
        >
          <ListSelect />
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box px={1}>
              {isSavedToServer == 0 && (
                <Box display="flex" alignItems="center">
                  <CloseIcon color="secondary" />
                  서버에 저장되지 않음
                </Box>
              )}
              {isSavedToServer == 1 && (
                <div>
                  <CheckIcon color="primary" />
                  {IPUtility.getCurrentTime(saveTime)}에 서버에 저장 됨
                </div>
              )}
              {isSavedToServer == 2 && <div>저장중...</div>}
            </Box>
            <Box px={1}>
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  openItemReviewList(true);
                }}
              >
                <PhotoIcon />
                면담사진
              </Button>
            </Box>
            <Box px={1}>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => {
                  openItemReviewList(false);
                }}
              >
                <EventNoteIcon />
                총평자료
              </Button>
            </Box>
          </Box>
        </Box>
      </div>
      {evaluationToggle && (
        <div className={classes.evaluation}>
          <table>
            <thead>
              <tr>
                <th colSpan={4}>프로젝트</th>
                <th colSpan={4}>{IPUtility.getContainerByUID(myProject, selectContainer).name}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>배점</td>
                <td>평가점수</td>
                <td>환산점수</td>
                <td>평가등급</td>
                <td>배점</td>
                <td>평가점수</td>
                <td>환산점수</td>
              </tr>
              <tr>
                <td>{scoreProject?.totalAssginedPoints}</td>
                <td>{IPUtility.getProjectPoint(myProject)}</td>
                <td>{scoreProject?.totalConvertPoints?.toFixed(2)}</td>
                <td>{IPUtility.getEvalLevel(scoreProject?.totalConvertPoints)}</td>
                <td>{containerAssignedPoint}</td>
                <td>{containerEvalPoint}</td>
                <td>
                  {containerAssignedPoint > 0
                    ? ((containerEvalPoint / containerAssignedPoint) * 100).toFixed(2)
                    : 0}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {helpToggle && (
        <div className={classes.help}>
          <p>
            {myProject.help ? (
              myProject.help.split("\n").map((x) => {
                return (
                  <span>
                    {x}
                    <br />
                  </span>
                );
              })
            ) : (
              <span>등록된 도움말이 없습니다.</span>
            )}
          </p>
          <HighlightOffIcon
            color="secondary"
            onClick={() => {
              dispatch(helpToggleAction());
            }}
          />
        </div>
      )}
      <TableContainer component={Paper} className={classes.container} style={{marginTop: "128px"}}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.tableHead}>
            <TableRow>
              {tableHeader.map((headerTitle, index) =>
                (!isGuideShow && headerTitle === "가이드") ||
                (myProject.isNoPoint && headerTitle === "점수") ? null : (
                  <TableCell key={index} align="center">
                    {headerTitle}
                  </TableCell>
                )
              )}
              {getReference.map((project, index) => (
                <TableCell key={project.uid} align="center">
                  <Box className={classes.header}>
                    <p> {project.name}</p>
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<DeleteIcon />}
                      onClick={() => {
                        dispatch(deleteReferenceAction(project.uid));
                      }}
                    >
                      삭제
                    </Button>
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {myProject.categories.map((category, index) =>
              category.containers.map((container) =>
                container.items.map((item, itemIndex) => {
                  const isNoCheck = myProject.noContentItemUIDs.indexOf(item.uid) > -1;
                  if (container.uid === selectContainer) {
                    return (
                      <StyledTableRow key={"item-" + item.uid}>
                        <TableCell className={classes.itemHead} width="250px">
                          <p>{item.name}</p>
                          {category.name === "현장 확인" && (
                            <Box className={classes.btnAttachBox}>
                              <Button
                                className={classes.buttonMargin}
                                onClick={() => {
                                  dispatch(
                                    selectItemAction({
                                      uid: item.uid,
                                      name: item.name,
                                    })
                                  );
                                  dispatch(checkListOpenAction());
                                  dispatch(checkListSwitchAction(0));
                                }}
                                size="small"
                                variant="contained"
                                color="primary"
                                startIcon={<FileCopyIcon />}
                              >
                                첨부
                              </Button>
                              <FormControlLabel
                                name="checked"
                                value="start"
                                control={
                                  <Checkbox
                                    color="primary"
                                    defaultChecked={isNoCheck}
                                    onChange={(e) => {
                                      dispatch(
                                        checkAction({
                                          uid: item.uid,
                                          isChecked: e.target.checked,
                                        })
                                      );
                                    }}
                                  />
                                }
                                label="해당사항없음"
                                labelPlacement="start"
                              />
                            </Box>
                          )}
                          <Button
                            className={classes.btnSearch}
                            onClick={() => {
                              dispatch(
                                selectItemAction({
                                  uid: item.uid,
                                  name: item.name,
                                })
                              );
                              dispatch(quotationListOpenAction());
                            }}
                            color="secondary"
                            size="small"
                            variant="contained"
                          >
                            검색
                          </Button>
                        </TableCell>
                        {!myProject.isNoPoint && (
                          <TableCell width="100px" align="center">
                            {/* <Box className={classes.score}>
                              <p>평가 점수</p>
                              <p>
                                <strong>[{IPUtility.getAutoPoint(item)}]</strong>
                              </p>
                            </Box> */}
                            <FormControl variant="outlined">
                              <Select
                                defaultValue={IPUtility.getItemPoint(myProject, item.uid)}
                                onChange={(event) => {
                                  dispatch(
                                    setManualPointAction({
                                      itemUID: item.uid,
                                      point: event.target.value as number,
                                    })
                                  );
                                }}
                              >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={8}>8</MenuItem>
                                <MenuItem value={6}>6</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={0}>0</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                        )}
                        <TableCell width="460px">
                          {item.projectItemValues
                            .filter((x) => x.writerUID !== thisUser.uid)
                            .map(
                              (value) =>
                                value && (
                                  <Box
                                    key={"pval-" + item.uid + "-" + value.uid}
                                    className={classes.itemValue}
                                  >
                                    <Box className={classes.writer}>
                                      <p>{value.writerName}</p>
                                    </Box>
                                    <Box className={classes.item}>
                                      {value.general && (
                                        <p>
                                          <i>일반 : {value.general} </i>
                                          <span></span>
                                        </p>
                                      )}
                                      {value.regulation && (
                                        <p>
                                          <i>법규 : {value.regulation} </i>
                                          <span></span>
                                        </p>
                                      )}
                                      {value.instruction && (
                                        <p>
                                          <i>지침 : {value.instruction}</i>
                                          <span></span>
                                        </p>
                                      )}
                                      {value.recommendation && (
                                        <p>
                                          <i>권고 : {value.recommendation} </i>
                                          <span></span>
                                        </p>
                                      )}
                                    </Box>
                                  </Box>
                                )
                            )}
                          <Box width="100%">
                            <Box display="flex" alignItems="center" mb={2}>
                              <Tooltip
                                title={IPConstants.generalTooltipMessage}
                                arrow
                                placement="right"
                              >
                                <Button
                                  className={classes.buttonMargin}
                                  style={{backgroundColor: theme.palette.success.light}}
                                  onClick={async () => {
                                    dispatch(
                                      updateGeneralContent({
                                        itemUid: item.uid,
                                        // general: IPUtility.getString(item.myItemValue.general),
                                        general: await navigator.clipboard.readText(),
                                      })
                                    );
                                    setGeneralKey(IPUtility.generateUUID());
                                  }}
                                  size="small"
                                  variant="contained"
                                  color="primary"
                                  startIcon={<FileCopyIcon />}
                                >
                                  일반
                                </Button>
                              </Tooltip>
                              <textarea
                                key={generalKey}
                                rows={3}
                                onBlur={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                  dispatch(
                                    updateGeneralContent({
                                      itemUid: item.uid,
                                      general: e.target.value,
                                    })
                                  );

                                  e.preventDefault();
                                }}
                                className={classes.textArea}
                                defaultValue={item.myItemValue.general}
                              />
                            </Box>
                            <Box display="flex" alignItems="center" mb={2}>
                              <Tooltip
                                title={IPConstants.regulationTooltipMessage}
                                arrow
                                placement="right"
                              >
                                <Button
                                  className={classes.buttonMargin}
                                  style={{backgroundColor: theme.palette.error.main}}
                                  onClick={async () => {
                                    dispatch(
                                      updateRegulationContent({
                                        itemUid: item.uid,
                                        // regulation: IPUtility.getString(item.myItemValue.regulation),
                                        regulation: await navigator.clipboard.readText(),
                                      })
                                    );
                                    setRegulationKey(IPUtility.generateUUID());
                                  }}
                                  size="small"
                                  variant="contained"
                                  color="primary"
                                  startIcon={<FileCopyIcon />}
                                >
                                  법규
                                </Button>
                              </Tooltip>
                              <textarea
                                key={regulationKey}
                                onBlur={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                  dispatch(
                                    writtenContentsAction({
                                      itemUid: item.uid,
                                      regulation: e.target.value,
                                    })
                                  );
                                  e.preventDefault();
                                }}
                                rows={3}
                                className={classes.textArea}
                                defaultValue={item.myItemValue.regulation}
                              />
                            </Box>
                            <Box display="flex" alignItems="center" mb={2}>
                              <Tooltip
                                title={IPConstants.instructionTooltipMessage}
                                arrow
                                placement="right"
                              >
                                <Button
                                  className={classes.buttonMargin}
                                  style={{backgroundColor: theme.palette.warning.main}}
                                  onClick={async () => {
                                    dispatch(
                                      writtenContentsAction({
                                        itemUid: item.uid,
                                        // instruction: IPUtility.getString(item.myItemValue.instruction),
                                        instruction: await navigator.clipboard.readText(),
                                      })
                                    );
                                    setInstructionKey(IPUtility.generateUUID());
                                  }}
                                  size="small"
                                  variant="contained"
                                  color="primary"
                                  startIcon={<FileCopyIcon />}
                                >
                                  지침
                                </Button>
                              </Tooltip>
                              <textarea
                                key={instructionKey}
                                onBlur={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                  dispatch(
                                    writtenContentsAction({
                                      itemUid: item.uid,
                                      instruction: e.target.value,
                                    })
                                  );
                                  e.preventDefault();
                                }}
                                rows={3}
                                className={classes.textArea}
                                defaultValue={item.myItemValue.instruction}
                              />
                            </Box>
                            <Box display="flex" alignItems="center">
                              <Tooltip
                                title={IPConstants.recommendationTooltipMessage}
                                arrow
                                placement="right"
                              >
                                <Button
                                  className={classes.buttonMargin}
                                  style={{backgroundColor: theme.palette.info.main}}
                                  onClick={async () => {
                                    dispatch(
                                      writtenContentsAction({
                                        itemUid: item.uid,
                                        // recommendation: IPUtility.getString(item.myItemValue.recommendation),
                                        recommendation: await navigator.clipboard.readText(),
                                      })
                                    );
                                    setRecommendationKey(IPUtility.generateUUID());
                                  }}
                                  size="small"
                                  variant="contained"
                                  color="primary"
                                  startIcon={<FileCopyIcon />}
                                >
                                  권고
                                </Button>
                              </Tooltip>
                              <textarea
                                key={recommendationKey}
                                onBlur={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                  dispatch(
                                    writtenContentsAction({
                                      itemUid: item.uid,
                                      recommendation: e.target.value,
                                    })
                                  );
                                  e.preventDefault();
                                }}
                                rows={3}
                                className={classes.textArea}
                                defaultValue={item.myItemValue.recommendation}
                              />
                            </Box>
                          </Box>
                        </TableCell>

                        {/* guide */}
                        {isGuideShow && (
                          <TableCell width="500px">
                            {item.guides.map((guides, index) => (
                              <Box
                                key={"guide-" + item.uid + "-" + guides.uid + "-" + index}
                                display="flex"
                                alignItems="center"
                                mb={2}
                              >
                                <Button
                                  className={classes.guideButton}
                                  onClick={() => {
                                    // instruction: IPUtility.copyString(
                                    //   guides.guide
                                    // );
                                    handleCopyClipBoard(guides.guide);
                                  }}
                                  size="small"
                                  variant="contained"
                                  color="secondary"
                                  startIcon={<FileCopyIcon />}
                                ></Button>
                                <p>{guides.guide}</p>
                              </Box>
                            ))}
                          </TableCell>
                        )}

                        {/* reference */}
                        {getReference.map((reference, index) =>
                          reference.categories
                            .find((category) => category.uid === selectCategory)
                            ?.containers.find((container) => container.uid === selectContainer)
                            ?.items.map(
                              (refItem) =>
                                refItem.uid === item.uid && (
                                  <TableCell key={"ref" + reference.uid + "-" + container.uid}>
                                    <Typography style={{marginBottom: "10px"}}>
                                      {/* 점수 : {IPUtility.getProjectItemPoint(refItem)} */}
                                      점수 :{" "}
                                      {
                                        reference.manualPointsList.find(
                                          (x) => x.itemUID == refItem.uid
                                        )?.point
                                      }
                                    </Typography>
                                    {refItem.projectItemValues.map((value, index) => (
                                      <Box
                                        key={"refval-" + item.uid + "-" + value.uid + "-" + index}
                                      >
                                        {value.general && (
                                          <Box display="flex" alignItems="center" mb={2}>
                                            <Button
                                              className={classes.buttonMargin}
                                              onClick={() => {
                                                // IPUtility.copyString(
                                                //   value.general
                                                // );
                                                handleCopyClipBoard(value.general);
                                                dispatch(
                                                  addCopiedCount({
                                                    userToken,
                                                    id: refItem.uid,
                                                    type: 0,
                                                  })
                                                );
                                              }}
                                              size="small"
                                              variant="contained"
                                              color="primary"
                                              startIcon={<FileCopyIcon />}
                                            >
                                              일반
                                            </Button>

                                            <p>{value.general}</p>
                                          </Box>
                                        )}
                                        {value.regulation && (
                                          <Box display="flex" alignItems="center" mb={2}>
                                            <Button
                                              className={classes.buttonMargin}
                                              onClick={() => {
                                                // IPUtility.copyString(
                                                //   value.regulation
                                                // );
                                                handleCopyClipBoard(value.regulation);
                                                dispatch(
                                                  addCopiedCount({
                                                    userToken,
                                                    id: refItem.uid,
                                                    type: 1,
                                                  })
                                                );
                                              }}
                                              size="small"
                                              variant="contained"
                                              color="primary"
                                              startIcon={<FileCopyIcon />}
                                            >
                                              법규
                                            </Button>
                                            <p>{value.regulation}</p>
                                          </Box>
                                        )}
                                        {value.instruction && (
                                          <Box display="flex" alignItems="center" mb={2}>
                                            <Button
                                              className={classes.buttonMargin}
                                              onClick={() => {
                                                // IPUtility.copyString(
                                                //   value.instruction
                                                // );
                                                handleCopyClipBoard(value.instruction);
                                                dispatch(
                                                  addCopiedCount({
                                                    userToken,
                                                    id: refItem.uid,
                                                    type: 2,
                                                  })
                                                );
                                              }}
                                              size="small"
                                              variant="contained"
                                              color="primary"
                                              startIcon={<FileCopyIcon />}
                                            >
                                              지침
                                            </Button>
                                            <p>{value.instruction}</p>
                                          </Box>
                                        )}
                                        {value.recommendation && (
                                          <Box display="flex" alignItems="center" mb={2}>
                                            <Button
                                              className={classes.buttonMargin}
                                              onClick={() => {
                                                // IPUtility.copyString(
                                                //   value.recommendation
                                                // );
                                                handleCopyClipBoard(value.recommendation);
                                                dispatch(
                                                  addCopiedCount({
                                                    userToken,
                                                    id: refItem.uid,
                                                    type: 3,
                                                  })
                                                );
                                              }}
                                              size="small"
                                              variant="contained"
                                              color="primary"
                                              startIcon={<FileCopyIcon />}
                                            >
                                              권고
                                            </Button>
                                            <p>{value.recommendation}</p>
                                          </Box>
                                        )}
                                      </Box>
                                    ))}
                                  </TableCell>
                                )
                            )
                        )}
                      </StyledTableRow>
                    );
                  } else {
                    return null;
                  }
                })
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <SpeedDials />
    </>
  );
};

export default EditMyProject;
